import { FirebaseProvider } from "@timebanken/firebase-context"
import { useTenant } from "@timebanken/firebase-context"
import type React from "react"

interface CustomerAppProps {
  children: React.ReactNode
}

export const CustomerApp: React.FC<CustomerAppProps> = ({ children }) => {
  const { databaseId } = useTenant()

  // Pass the databaseId from the context to the provider.
  // If it's null (pre-login), FirebaseProvider will use its default.
  return (
    <FirebaseProvider databaseId={databaseId || "(default)"}>
      {children}
    </FirebaseProvider>
  )
}
